var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Pagination',{staticClass:"scroll-animate fadeInUp",attrs:{"data-vp-add-class":"visible-animation","value":_vm.page,"pageCount":_vm.pageCount,"url-factory":_vm.getUrl},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }